import React, { Component } from 'react';
import {
  Input
} from '@material-ui/core';
import PropTypes from 'prop-types';


class NumericModelMeasurement extends Component {
  render() {
    const { measurementKey, modelMeasurement, handleModelMeasurementChange, inEditMode } = this.props;

    return (
      <Input
        fullWidth
        value={
          modelMeasurement[measurementKey]
            ? modelMeasurement[measurementKey]
            : 0
        }
        disabled={!inEditMode}
        disableUnderline={!inEditMode}
        onChange={event =>
          handleModelMeasurementChange(
            {[measurementKey]:parseInt(event.target.value,10)},
            measurementKey
          )
        }
      />
    )
  }
}

NumericModelMeasurement.propTypes = {
  measurementKey: PropTypes.string.isRequired,
  inEditMode: PropTypes.bool.isRequired,
  modelMeasurement: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])).isRequired,
  handleModelMeasurementChange: PropTypes.func.isRequired,
}

export default NumericModelMeasurement;